(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.faq__question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      var list = btn.closest('.faq__list');
      if (list) {
        list.querySelectorAll('.faq__question[aria-expanded="true"]').forEach(function(other) {
          if (other !== btn) {
            other.setAttribute('aria-expanded', 'false');
            var ans = document.getElementById(other.getAttribute('aria-controls'));
            if (ans) ans.hidden = true;
          }
        });
      }
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      var answer = document.getElementById(btn.getAttribute('aria-controls'));
      if (answer) answer.hidden = isOpen;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-buybox"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionId = document.currentScript ? document.currentScript.closest('[id^="ww-bb-"]') : null;

  // Thumbnail gallery swap
  document.querySelectorAll('.ww-bb__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var bbWrap = thumb.closest('.ww-bb__gallery');
      if (!bbWrap) return;
      var target = thumb.getAttribute('data-target');
      bbWrap.querySelectorAll('.ww-bb__thumb').forEach(function(t) { t.classList.remove('ww-bb__thumb--active'); });
      thumb.classList.add('ww-bb__thumb--active');
      var section = thumb.closest('[id^="ww-bb-"]');
      if (!section) return;
      var secId = section.id.replace('ww-bb-', '');
      var heroImg = section.querySelector('#bb-hero-img');
      if (heroImg) heroImg.hidden = target !== 'product';
      section.querySelectorAll('[id^="bb-callout-"]').forEach(function(card) { card.hidden = true; });
      if (target !== 'product') {
        var idx = target.replace('callout-', '');
        var callout = section.querySelector('#bb-callout-' + idx + '-' + secId);
        if (callout) callout.hidden = false;
      }
    });
  });

  // Buy box accordion
  document.querySelectorAll('.ww-bb__acc-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      var accordion = btn.closest('.ww-bb__accordion');
      if (accordion) {
        accordion.querySelectorAll('.ww-bb__acc-btn[aria-expanded="true"]').forEach(function(other) {
          if (other !== btn) {
            other.setAttribute('aria-expanded', 'false');
            var body = document.getElementById(other.getAttribute('aria-controls'));
            if (body) body.hidden = true;
          }
        });
      }
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      var body = document.getElementById(btn.getAttribute('aria-controls'));
      if (body) body.hidden = isOpen;
    });
  });

  // Quantity stepper
  document.querySelectorAll('.ww-bb__form').forEach(function(form) {
    var minus = form.querySelector('#bb-qty-minus');
    var plus  = form.querySelector('#bb-qty-plus');
    var input = form.querySelector('#bb-qty-input');
    if (!minus || !plus || !input) return;
    minus.addEventListener('click', function() {
      var v = parseInt(input.value, 10);
      if (v > 1) input.value = v - 1;
    });
    plus.addEventListener('click', function() {
      var v = parseInt(input.value, 10);
      input.value = v + 1;
    });
  });

  // Sticky bar (IntersectionObserver)
  document.querySelectorAll('[id^="ww-sticky-"]').forEach(function(sticky) {
    var secId = sticky.id.replace('ww-sticky-', '');
    var atc = document.getElementById('bb-atc-' + secId);
    if (!atc || !sticky) return;
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var show = !entry.isIntersecting;
        sticky.classList.toggle('ww-sticky--visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }, { threshold: 0, rootMargin: '-80px 0px 0px 0px' });
    io.observe(atc);
  });

  // Sticky ATC click — submit parent form
  document.querySelectorAll('[id^="ww-sticky-atc-"]').forEach(function(stickyBtn) {
    stickyBtn.addEventListener('click', function() {
      var variantId = stickyBtn.getAttribute('data-variant-id');
      if (!variantId) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function() {
        window.location.href = '/cart';
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-review-wall"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.urw__load-more').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var gridId = btn.getAttribute('data-grid-id');
      var grid = document.getElementById(gridId);
      if (!grid) return;
      grid.querySelectorAll('.urw__card--hidden').forEach(function(card) {
        card.classList.remove('urw__card--hidden');
      });
      btn.closest('.urw__load-more-wrap').remove();
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
